export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_03.e22609f1.JPG";